import _slicedToArray from "@babel/runtime/helpers/slicedToArray";
import { Icon, SimpleModal } from '@livable/saas-react-components';
import { Button } from '@mui/material';
import { observer } from 'mobx-react-lite';
import React, { useState, useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import { events, track } from 'src/configs/amplitude';
import { useStore } from 'src/stores';
import { EnrollResident } from './EnrollResident';
export const EnrollmentModal = observer(props => {
  const store = useStore();
  const _useTranslation = useTranslation(),
    t = _useTranslation.t;
  const handleShowCurrentEnrollModal = props.handleShowCurrentEnrollModal,
    page = props.page,
    propertyId = props.propertyId,
    showCurrentEnrollModal = props.showCurrentEnrollModal,
    trigger = props.trigger,
    unitIsDefined = props.unitIsDefined,
    enablePortfolioSelect = props.enablePortfolioSelect,
    portfolioId = props.portfolioId,
    newBillingActivated = props.newBillingActivated,
    triggerRefresh = props.triggerRefresh,
    parentToggleRefreshCallback = props.parentToggleRefreshCallback;
  const _useState = useState(unitIsDefined ? unitIsDefined : undefined),
    _useState2 = _slicedToArray(_useState, 2),
    activeUnitName = _useState2[0],
    setActiveUnitName = _useState2[1];
  const _useState3 = useState(false),
    _useState4 = _slicedToArray(_useState3, 2),
    modalIsOpen = _useState4[0],
    setModalIsOpen = _useState4[1];
  const _useState5 = useState(null),
    _useState6 = _slicedToArray(_useState5, 2),
    unitAvailableFromDateOnly = _useState6[0],
    setUnitAvailableFromDateOnly = _useState6[1];
  const handleOpenModal = () => {
    setModalIsOpen(true);
  };
  const defaultTrigger = /*#__PURE__*/React.createElement(Button, {
    onClick: () => track(events.modalOpened('Enroll Resident'), {
      page
    }),
    variant: "action",
    'custom-attribute': '234-EnrollmentModal'
  }, /*#__PURE__*/React.createElement(Icon, {
    type: "move-in"
  }), t('enrollment_modal.enroll_new_resident'));
  const getModalTitle = () => {
    if (activeUnitName) return t('enrollment_modal.enroll_resident_in_unit', {
      unit: activeUnitName
    });
    return t('enrollment_modal.enroll_resident');
  };
  useEffect(() => {
    if (handleShowCurrentEnrollModal && showCurrentEnrollModal) {
      setActiveUnitName(undefined);
      setModalIsOpen(true);
      handleShowCurrentEnrollModal(false);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [showCurrentEnrollModal]);
  const handleClose = () => {
    try {
      track(events.modalClosed('Enroll Resident'), {
        page
      });
      setUnitAvailableFromDateOnly(null);
      store.enrollResident.clearData();
      store.residencies.makesPropertyAddressAsPrimary();
      store.residencies.toggleRefreshFlag(true);
      store.residencies.resetDataGrid();
      // eslint-disable-next-line @typescript-eslint/no-unused-expressions
      triggerRefresh && triggerRefresh(propertyId);
      setModalIsOpen(false);
    } catch (e) {
      console.error(e);
    }
  };
  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(SimpleModal, {
    handleClose: handleClose,
    handleOpen: handleOpenModal,
    isOpen: modalIsOpen,
    noFooter: true,
    noPadding: true,
    title: getModalTitle(),
    trigger: trigger !== undefined ? trigger : defaultTrigger,
    variant: "middle"
  }, /*#__PURE__*/React.createElement(EnrollResident, {
    handleClose: handleClose,
    propertyId: propertyId,
    setActiveUnitName: setActiveUnitName,
    unitAvailableFromDateOnly: unitAvailableFromDateOnly,
    enablePortfolioSelect: enablePortfolioSelect,
    portfolioId: portfolioId,
    newBillingActivated: newBillingActivated,
    parentToggleRefreshCallback: parentToggleRefreshCallback
  })));
});